import { useContext } from 'react';
import ReportPrintContext from '../../StateManagment/ReportPrintContext';

/** @typedef {import('../../helpers/dataHelpers/chartDataTable').ChartTable} ChartTable */

/** Een getal of het streepje voor 'niets gemeten'. */
const isNumberCell = (cell) => /^[\d.,–-]+$/.test(cell);

/**
 * De cijfers achter een grafiek als tabel. Zichtbaar op het PDF-vel van een
 * live rapportage: op papier kun je niet met de muis over een staaf.
 * Op het scherm staat hij verborgen klaar (de tooltip toont de cijfers daar
 * al); 'Kopiëren als afbeelding' maakt hem in de kopie zichtbaar
 * (copyElementAsImage → revealForCopy). Updateverzoek Groentjessoep, 2026-10-26.
 *
 * @param {object} props
 * @param {ChartTable|null} props.table - Uit chartDataTable; null = geen gegevens, dan geen tabel
 * @returns {JSX.Element|null}
 */
const ChartDataTable = ({ table }) => {
    const inPrint = useContext(ReportPrintContext);
    if (!table) return null;

    // Per kolom: alleen getallen → kop en cellen rechts, zodat de cijfers
    // onder elkaar uitlijnen. Tekst (stelling, meetmoment) blijft links, en de
    // eerste kolom is altijd het label van de rij — ook bij antwoorden '1', '2'.
    const numberClass = table.columns.map((_, c) => (
        c > 0 && table.rows.length > 0 && table.rows.every(row => isNumberCell(row[c])) ? 'chart-data-table-number' : undefined
    ));

    return (
        <table className="chart-data-table" hidden={!inPrint}>
            <thead>
                <tr>
                    {table.columns.map((column, c) => <th key={c} className={numberClass[c]}>{column}</th>)}
                </tr>
            </thead>
            <tbody>
                {table.rows.map((row, r) => (
                    <tr key={r}>
                        {row.map((cell, c) => (
                            <td key={c} className={numberClass[c]}>{cell}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ChartDataTable;
